import React from 'react';
import './Info.css';

import aboutPhoto from '../assets/images/about/sobre.webp';
function Info() {
  return (
    <section className="info-section" id="sobre">
      <div className="info-container">
        <div className="info-text">
          <h2>SOBRE NÓS</h2>
          <p>A Edifica 3D transforma ideias em estruturas sólidas. Mais do que impressão 3D, criamos soluções com base, precisão e propósito, feitas para durar.</p>
          <p>Cada projeto é tratado como único, com tecnologia avançada, atenção aos detalhes e fácil comunicação, garantindo resultados personalizados e confiáveis. Trabalhamos com planejamento, qualidade e iterações precisas.</p>
          <p>Oferecemos desde prototipagem rápida a peças personalizadas funcionais, com materiais sustentáveis e metodologia específica e integrada com confiança.</p>
        </div>
        <div className="info-photo">
          <div className="photo-placeholder">
            <img src={aboutPhoto} alt="Sobre a Edifica 3D" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Info;
